import { motion } from "framer-motion";
import { ShieldCheck, KeyRound, Smartphone, Users } from "lucide-react";

const features = [
  {
    icon: <ShieldCheck className="w-6 h-6 text-cyan-600" />,
    title: "Advanced Security",
    description:
      "Strong encryption and customizable password rules keep your accounts safe.",
  },
  {
    icon: <KeyRound className="w-6 h-6 text-cyan-600" />,
    title: "Account Profiles",
    description:
      "Generate passwords tailored for different accounts like banking, email, or social media.",
  },
  {
    icon: <Smartphone className="w-6 h-6 text-cyan-600" />,
    title: "Multi-Factor Authentication",
    description:
      "Add an extra layer of protection with 2FA or multi-factor authentication.",
  },
  {
    icon: <Users className="w-6 h-6 text-cyan-600" />,
    title: "Team Support",
    description:
      "Manage and securely share passwords across your team or organization.",
  },
];

export default function FeaturesGrid() {
  return (
    <div className="mt-12 max-w-6xl mx-auto px-4">
      {/* Section Header */}
      <div className="text-center mb-8">
        <h2 className="text-3xl font-bold text-gray-800">Why Choose Our Tool?</h2>
        <p className="text-gray-600 mt-2">
          Our password generator comes with advanced security features to protect your accounts.
        </p>
      </div>

      {/* Features Grid */}
      <div className="grid md:grid-cols-2 gap-6">
        {features.map((feature, index) => (
          <motion.div
            key={index}
            className="p-4 border rounded-xl bg-gray-50 shadow-sm hover:shadow-md transition"
            whileHover={{ y: -3, scale: 1.02 }}
            transition={{ type: "spring", stiffness: 200, damping: 10 }}
          >
            <div className="flex items-center gap-3 mb-2">
              {feature.icon}
              <h3 className="font-semibold text-gray-800">{feature.title}</h3>
            </div>
            <p className="text-sm text-gray-600">{feature.description}</p>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
